import {
  NEW_WINDOW_DEAFULT_HEIGHT,
  NEW_WINDOW_DEAFULT_WIDTH,
} from "@/constants";

interface OpenNewWindowOptions {
  isPreview?: boolean;
  width?: number;
  height?: number;
  noopener?: boolean;
  noreferrer?: boolean;
}

export const openNewWindow = (
  url: string,
  options: OpenNewWindowOptions = {},
) => {
  const {
    isPreview = false,
    width = NEW_WINDOW_DEAFULT_WIDTH,
    height = NEW_WINDOW_DEAFULT_HEIGHT,
  } = options;

  const noopener =
    options.noopener !== undefined ? options.noopener : isPreview;
  const noreferrer =
    options.noreferrer !== undefined ? options.noreferrer : isPreview;

  const features = [];
  if (noopener) features.push("noopener");
  if (noreferrer) features.push("noreferrer");
  if (isPreview) {
    features.push(`width=${width}`);
    features.push(`height=${height}`);
  }

  return window.open(url, "_blank", features.join(","));
};
